import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcpBadgeComponent } from './fcp-badge.component';

const components = [FcpBadgeComponent];
@NgModule({
    imports: [CommonModule],
    declarations: components,
    exports: components
})
export class FcpBadgeModule {}
